export class LocalStorageConstants {
  public static readonly PROJECT_ROADMAP_PREFERENCES = "Project_Roadmap_Preferences";

  public static readonly PROJECT_TRACKER_PREFERENCES = "Project_Tracker_Preferences";

  public static readonly PROJECT_INVENTORY_PREFERENCES = "Project_Inventory_Preferences";

  public static readonly PROJECT_INVENTORY_UNIT_TRANSACTIONS_PREFERENCES =
    "Project_Inventory_Unit_Transactions_Preferences";

  public static readonly PIPELINE_TRACKER_PREFERENCES = "Pipeline_Tracker_Preferences";

  public static readonly PIPELINE_ROADMAP_PREFERENCES = "Pipeline_Roadmap_Preferences";

  public static readonly DEAL_LISTING_KPI_PREFERENCES = "Deal_Listing_KPI_Preferences";
}
